import { render, staticRenderFns } from "./wsNotification.vue?vue&type=template&id=09ac8b8f&scoped=true&"
import script from "./wsNotification.vue?vue&type=script&lang=js&"
export * from "./wsNotification.vue?vue&type=script&lang=js&"
import style0 from "./wsNotification.vue?vue&type=style&index=0&id=09ac8b8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ac8b8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
